import axios from 'axios';

import { ViewerSession } from './types';

export async function getConvivaViewerSession(oktaId: string): Promise<ViewerSession[]> {
  const response = await axios.get(`/sessions/content/viewer?viewer_id=${oktaId}&days=3`, {
    auth: {
      //secret
      password: '2qrUt2CzJqeKcB7eJcJPDHfxE1XLeJVAsTnnqxn3shfE',
      // clientid
      username: 'AmLDGVGm1yfHZuMkqJM4Bo',
    },
    headers: {
      Accept: 'application/json',
    },
  });

  return response.data.viewer_sessions;
}
